<template>
  <div class="login-box">
    <div class="login-logo-box">
      <img :src="require('@/assets/images/weChat.png')" class="login-logo"/>
    </div>
    <div class="login-content">
      <div class="login-title">申请获取以下权限</div>
      <div class="login-text">
        获得你的公开信息（昵称、头像）
      </div>
      <van-button type="info" round class="login-btn" @click="confirmLogin">授权登录</van-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  components: {},
  mounted() {
  },
  created() {
  },
  data() {
    return {}
  },
  methods: {
    goThere(loginType, appid, redirect_uri) {
      if (loginType == 2) {
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
      } else if (loginType == 1) {
        window.location.href = "https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=" + appid + "&scope=auth_user&redirect_uri=" + redirect_uri
      }
    },
    confirmLogin() {
      let initData = {
        loginType: this.loginType,
        deviceNum: this.deviceNum
      }
      this.$api.login.loginInit(initData).then(res => {
        if (res.code == 200) {
          let redirect_uri = encodeURIComponent(res.redirect_uri), appid = res.appId
          this.goThere(this.loginType, appid, redirect_uri)
        } else {
          this.$router.push({name: 'home'})
        }
      })
    }
  }
}
</script>
<style scoped>
.login-box {
  width: 100vw;
  height: 100%;
  text-align: center;
}

.login-box .login-logo-box {
  margin: 120px 60px;
  display: inline-block;
  height: 120px;
  width: 120px;
  border-radius: 50%;
  overflow: hidden;
}

.login-box .login-logo {
  height: 120px;
  width: 120px;
}

.login-box .login-content {
  border-top: 1px solid #ccc;
  padding: 40px 0 0;
  margin: 0 50px;
  width: calc(100% - 100px);
}

.login-box .login-title {
  color: #000;
  text-align: left;
  line-height: 80px;
  font-size: 38px;
}

.login-box .login-text {
  color: #9d9d9d;
  text-align: left;
  line-height: 80px;
  font-size: 30px;
}

.login-box .login-btn {
  background-color: #1dad18;
  border-color: #1dad18;
  color: #fff;
  height: 88px;
  line-height: 88px;
  margin-top: 40px;
  width: 100%;
  font-size: 34px;
}
</style>
